export const APP_NAME = 'app6';